(function() {
    'use strict';

    angular.module("settings")
        .controller('TranslationModelsListController', TranslationModelsListController);

    TranslationModelsListController.$inject = ['translationDataSrvc', 'searchFilterSrvc', 'notificationSrvc', 'lodashService', 'datatableDefaultPageSizeValueConst', 'checkSearchSrvc', 'translationPermissionsConst', 'filterQuerySrvc', 'downloadLinkSrvc', 'translationMessagesConst', '$uibModal', 'checkModelPermissionsSrvc'];

    function TranslationModelsListController(translationDataSrvc, searchFilterSrvc, notificationSrvc, lodashService, datatableDefaultPageSizeValueConst, checkSearchSrvc, translationPermissionsConst, filterQuerySrvc, downloadLinkSrvc, translationMessagesConst, $uibModal, checkModelPermissionsSrvc) {
        var self = this;

        self.loading = true;
        self.exportTranslationsLoading = false;

        self.emptyCheckboxColumns = ['de', 'en', 'cpde', 'cpen'];
        self.emptyColumnsList = [];
        self.columnEmptyCheckboxChange = columnEmptyCheckboxChange;

        self.pageOpts = {
            count: undefined,
            page: 1,
            pageSize: datatableDefaultPageSizeValueConst
        };

        self.translationRows = [];
        self.translationCols = [{
            title: 'Model',
            value: 'model',
            type: 'text',
            searchable: true,
            orderable: true,
            isEditable: false
        }, {
            title: 'ID',
            value: 'id',
            type: 'text',
            searchable: true,
            orderable: true,
            isEditable: false
        }, {
            title: 'Pole',
            value: 'field',
            type: 'text',
            searchable: true,
            orderable: true,
            isEditable: false
        }, {
            title: 'Polski',
            value: 'pl',
            type: 'text',
            searchable: true,
            orderable: true,
            isEditable: true,
            required: false
        }, {
            title: 'Niemiecki',
            value: 'de',
            type: 'text',
            searchable: true,
            orderable: true,
            isEditable: true,
            required: false
        }, {
            title: 'Angielski',
            value: 'en',
            type: 'text',
            searchable: true,
            orderable: true,
            isEditable: true,
            required: false
        }, {
            title: 'Niemiecki (de)',
            value: 'cpde',
            type: 'text',
            searchable: true,
            orderable: true,
            isEditable: true,
            required: false
        }, {
            title: 'Angielski (de)',
            value: 'cpen',
            type: 'text',
            searchable: true,
            orderable: true,
            isEditable: true,
            required: false
        }];
        self.modelPermissions = translationPermissionsConst;

        self.searchQuery = {
            model: null,
            id: null,
            field: null,
            pl: null,
            de: null,
            en: null,
            cpde: null,
            cpen: null,
            ordering: null,
            onlyEmptyColumns: null
        };

        self.onEdit = onEdit;

        self.pageChange = pageChange;
        self.onSearchQueryChange = onSearchQueryChange;
        self.exportTranslations = exportTranslations;
        self.importTranslations = importTranslations;
        self.hasImportPermissions = hasImportPermissions;

        activate();

        function activate() {
            self.pageOpts = filterQuerySrvc.initializePageOpts(self.pageOpts);
            self.searchQuery = filterQuerySrvc.initializeSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            getTranslations();
        }

        function getTranslations(filterObj) {
            if (!filterObj) {
                filterObj = {
                    page: self.pageOpts.page,
                    page_size: self.pageOpts.pageSize,
                    model: self.searchQuery.model || null,
                    id: self.searchQuery.id || null,
                    field: self.searchQuery.field || null,
                    pl: self.searchQuery.pl || null,
                    de: self.searchQuery.de || null,
                    en: self.searchQuery.en || null,
                    cpde: self.searchQuery.cpde || null,
                    cpen: self.searchQuery.cpen || null,
                    ordering: self.searchQuery.ordering,
                    onlyEmptyColumns: self.emptyColumnsList

                };
            }
            return translationDataSrvc.modelsList(filterObj)
                .$promise
                .then(
                    function(response) {
                        self.translationRows = response.results;
                        self.pageOpts.count = response.count;
                        return response;
                    },
                    function(response) {
                        if (response.status === 404 && filterObj.page !== 1) {
                            checkSearchSrvc.recall(filterObj, getTranslations);
                        }
                    }
                ).finally(
                    function(response) {
                        self.loading = false;
                        return response;
                    }
                );
        }

        function onEdit(row) {
            return translationDataSrvc.modelsUpdate({}, row);
        }

        function pageChange() {
            self.loading = true;
            filterQuerySrvc.updatePageOpts(self.pageOpts);
            filterQuerySrvc.setLocationParams();
            return getTranslations();
        }

        function onSearchQueryChange() {
            self.loading = true;
            self.pageOpts.page = 1;
            filterQuerySrvc.updatePageOpts(self.pageOpts);
            filterQuerySrvc.updateSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            return getTranslations();
        }

        function columnEmptyCheckboxChange(selectedColumns) {
            self.emptyColumnsList = Object.keys(selectedColumns).map(function(key) {
                if (selectedColumns[key]){
                    return key;
                }
            });
            self.emptyColumnsList = self.emptyColumnsList.filter(function (el) {
                return el != null;
            });
            filterQuerySrvc.updatePageOpts(self.pageOpts);
            self.searchQuery['onlyEmptyColumns'] = self.emptyColumnsList;
            filterQuerySrvc.updateSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            return getTranslations();
        }

        function exportTranslations(filterObj) {
            if(!self.exportTranslationsLoading) {
                self.exportTranslationsLoading = true;

                if (!filterObj) {
                    filterObj = {
                        model: self.searchQuery.model || null,
                        id: self.searchQuery.id || null,
                        field: self.searchQuery.field || null,
                        pl: self.searchQuery.pl || null,
                        de: self.searchQuery.de || null,
                        en: self.searchQuery.en || null,
                        cpde: self.searchQuery.cpde || null,
                        cpen: self.searchQuery.cpen || null,
                        ordering: self.searchQuery.ordering
                    };
                }
                return translationDataSrvc.modelsExport(filterObj)
                    .$promise
                    .then(
                        function(response) {
                            downloadLinkSrvc.saveFile(response);
                            return response;
                        },
                        function(response) {
                            notificationSrvc.notification("error", translationMessagesConst.exportError);
                        }
                    ).finally(
                        function(response) {
                            self.exportTranslationsLoading = false;
                            return response;
                        }
                    );
            }
        }

        function hasImportPermissions() {
            return !checkModelPermissionsSrvc.isDenied(translationPermissionsConst.update);
        }

        function importTranslations() {
            if (!hasImportPermissions()) {
                return;
            }

            $uibModal.open({
                templateUrl: 'app/settings/views/translation-models-import-modal/translation-models-import-modal.html',
                controller: 'TranslationModelsImportModalController',
                controllerAs: 'ctrl',
                size: 'lg',
                resolve: {}
            }).result.then(
                function (results) {
                    self.loading = true;
                    getTranslations();
                    return results;
                }
            );
        }
    }
})();
